import { Brand } from "../../types/brand";

export const sortedBrandsByWeeklyScores = (brands: Brand[]) => {
  return brands.sort((a, b) => {
    if (!a.weeklyScores) return -1;
    if (!b.weeklyScores) return 1;

    return b.weeklyScores.current_week_avg_visibility - a.weeklyScores.current_week_avg_visibility;
  });
};

export const sortedBrandsByDailySeriesVisibility = (brands: Brand[]): Brand[] => {
  const lastVisibility = (b: Brand) => {
    const pts = b.scores?.scores;
    if (!pts?.length) return -Infinity;
    return pts[pts.length - 1].visibility;
  };
  return [...brands].sort((a, b) => lastVisibility(b) - lastVisibility(a));
};